import moment from 'moment-timezone'
import { diningPreferenceType } from './types'

// const startOfToday = moment().startOf('day').toISOString()
const startOfYesterday = moment().add(-1, 'days').startOf('day').toISOString()
const startOf2DaysBefore = moment().add(-2, 'days').startOf('day').toISOString()

export const filterConfigs = {
  getUnpaidFilterConfig (params) {
    const limit = params ? params.limit : 100
    const offset = params ? params.offset : 0
    return {
      id: 'unpaid',
      name: '尚未付款',
      limit,
      offset,
      conditions: [
        { diningPreference: diningPreferenceType.forHere, _compares: [['receivedAt', '>=', startOfYesterday]], _nulls: ['paidAt'] },
        { diningPreference: diningPreferenceType.takeAway, _compares: [['receivedAt', '>=', startOfYesterday]], _nulls: ['paidAt'] }
      ]
    }
  },
  getUnsentPreOrderFilterConfig (params) {
    const limit = params ? params.limit : 100
    const offset = params ? params.offset : 0
    const now = moment().toISOString()
    return {
      id: 'unsentPreOrder',
      name: '排程中',
      orderBy: [['startPreparingAt', 'ASC']],
      limit,
      offset,
      conditions: [
        { diningPreference: 'preOrder', _compares: [['startPreparingAt', '>=', now]], _notNulls: ['startPreparingAt'], _nulls: ['deliveredAt', 'refundedAt', 'deletedAt'] }
      ],
      fields: ['publicId', 'startPreparingAt']
    }
  },
  getPreOrderFilterConfig (params) {
    const limit = params ? params.limit : 100
    const offset = params ? params.offset : 0
    return {
      id: 'preOrder',
      name: '預約外帶',
      orderBy: [['pickupTime', 'ASC']],
      limit,
      offset,
      conditions: [
        { diningPreference: diningPreferenceType.preOrder, _compares: [['pickupTime', '>=', startOfYesterday]], _notNulls: ['pickupTime'], _nulls: ['deliveredAt', 'refundedAt'] }
      ]
    }
  },
  getKitchenFilterConfig (params) {
    const limit = params ? params.limit : 100
    const offset = params ? params.offset : 0
    const expectedTime = moment().add(5, 's').toISOString()
    return {
      id: 'kitchen',
      name: '廚房控單畫面',
      orderBy: [['diningPreference', 'EQ_FIRST', diningPreferenceType.preOrder], ['startPreparingAt', 'ASC']],
      limit,
      offset,
      conditions: [
        { diningPreference: diningPreferenceType.forHere, _compares: [['startPreparingAt', '>=', startOf2DaysBefore]], _nulls: ['doneAt', 'deliveredAt', 'refundedAt'] },
        { diningPreference: diningPreferenceType.takeAway, _compares: [['startPreparingAt', '>=', startOf2DaysBefore]], _nulls: ['doneAt', 'deliveredAt', 'refundedAt'] },
        { diningPreference: diningPreferenceType.preOrder, _compares: [['startPreparingAt', '>=', startOf2DaysBefore], ['startPreparingAt', '<=', expectedTime]], _nulls: ['doneAt', 'deliveredAt', 'refundedAt'] }
      ]
    }
  },
  getDoneFilterConfig (params) {
    const limit = params ? params.limit : 100
    const offset = params ? params.offset : 0
    return {
      id: 'done',
      name: '尚未取餐',
      conditions: [{ _compares: [['doneAt', '>=', startOfYesterday]], _notNulls: ['paidAt'], _nulls: ['deliveredAt', 'refundedAt'] }],
      orderBy: [['updatedAt', 'ASC']],
      limit,
      offset
    }
  },
  getDeliveredFilterConfig (params) {
    const limit = params ? params.limit : 300
    const offset = params ? params.offset : 0
    return {
      id: 'delivered',
      name: '已完成',
      orderBy: [['updatedAt', 'DESC']],
      limit,
      offset,
      conditions: [
        { _compares: [['deliveredAt', '>=', startOfYesterday]] },
        { _compares: [['refundedAt', '>=', startOfYesterday]] }
      ]
    }
  }
}
